import { TicketStatus } from './types';

export const TicketStatusMap = {
  [TicketStatus.TODO]: 'To do',
  [TicketStatus.IN_PROGRESS]: 'In progress',
  [TicketStatus.CLOSED]: 'Done',
  [TicketStatus.FORCE_CLOSED]: 'Closed'
};

export const ENTER_KEY = 'Enter';
